module.exports = __webpack_public_path__ + "evil.4175570f.png";